import React, { useCallback, useEffect, useState, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { createSelector } from 'reselect';

import { logging, logPostInfo } from '../../../actions/log';
import styles from './index.module.less';

import InfiniteScroll from 'react-infinite-scroller';
import CoolLogo from '../../../static/forum_logo.svg';
import { CONTEXT, MICROCONTEXT } from '../../../config';
import { useHistory, useLocation } from 'react-router-dom';
import { useActivate, useUnactivate } from 'react-activation';
import useLoginStatus from '../../../utils/hooks/useLoginStatus';
import CommentDetail from './CommentDetail';
import config, { sorts, grades } from '../config';
import Select from '../../Select/Select';
import { useInView } from 'react-intersection-observer';

const selectLogInfo = createSelector(
  state => state.log,
  log => log.logInfo,
);

function List(props) {
  const dispatch = useDispatch();
  const {
    scrollEl = document.getElementById('container_content'),
    // type, // 1-应用评论  2-专题评论  3-帖子评论
    forum,
    data,
    addCommentInfo, // 用户自己发生评论增加或则评论修改
    releaseInfo,
    requestInfo,
    handleUpdateRelase = () => {},
  } = props;
  const logInfoData = useSelector(selectLogInfo);
  const history = useHistory();
  const { pathname } = useLocation();
  const loginStatus = useLoginStatus();
  const [comments, setComments] = useState([]);
  const [commentPagenation, setCommmentPagenation] = useState({ count: 0 });
  const loading = useRef(false);
  const [queryParams, setQueryParams] = useState({
    labelCode: -1,
    grade: -1,
    sort: 'DATE',
  });
  const [currCommentOn, setCurrmentOn] = useState(null);
  const showCommentTime = useRef(null);

  const [ref, inView] = useInView({
    threshold: 0,
  });

  const getCommentList = useCallback(
    async (param = {}) => {
      if (releaseInfo?.commentSwitch === 2) {
        return;
      }
      try {
        let params = { ...queryParams, ...param };

        params = {
          ...params,
          skip: param?.refresh ? 0 : comments?.length,
          limit: 24,
          bizIdentity: data?.bizIdentity,
          type: data?.type,
        };

        const res = await config.getCommentList(params);
        setComments(list => {
          return param?.refresh ? res?.dataList || [] : [...list, ...(res?.dataList || [])];
        });
        setCommmentPagenation(state => ({
          ...state,
          count: res?.count || 0,
        }));
      } catch (err) {
        //
      }
      loading.current = false;
    },
    [data, queryParams, releaseInfo, comments],
  );

  const loadMore = async () => {
    if (!loading.current && commentPagenation.count > comments.length) {
      loading.current = true;
      await getCommentList({ refresh: false });
    }
  };

  const handleUpdate = data => {
    setComments(list => {
      const temp = list.map(item => {
        if (item.id === data?.commentId && data?.replyId) {
          return {
            ...item,
            replys: item?.replys?.map(i => {
              if (i?.id === data?.replyId) {
                return {
                  ...i,
                  hasZan: 1,
                  datas: {
                    ...(i.datas || {}),
                    zan: data?.zanCount,
                  },
                };
              }
              return i;
            }),
          };
        }
        if (item.id === data?.commentId && !data?.replyId) {
          return {
            ...item,
            hasZan: 1,
            datas: {
              ...(item.datas || {}),
              zan: data?.zanCount,
            },
          };
        }
        return item;
      });
      return temp;
    });
  };

  const handleUpdateByEditor = useCallback(
    (data, id, type, replyId) => {
      setComments(list => {
        if (type === 'comment') {
          return list?.map(item => ({
            ...item,
            replys: item.id === id ? [data, ...(item.replys || [])] : item.replys,
          }));
        }
        if (type === 'reply') {
          const findCommentIndex = list?.findIndex(item => item.id === id);
          const target = list[findCommentIndex].replys || [];
          const replyIndex = target?.findIndex(re => re.id === replyId) || [];
          const newReplys = [...list[findCommentIndex].replys];
          newReplys.splice(replyIndex + 1, 0, data);
          list[findCommentIndex].replys = newReplys;
          return JSON.parse(JSON.stringify(list));
        }

        return list;
      });
      if (!releaseInfo.commentContent) {
        handleUpdateRelase();
      }
    },
    [releaseInfo],
  );

  const handleForum = () => {
    dispatch(
      logging({
        category: 'C',
        action: 'AppDetail_Comment_Forum',
        label: '',
        param2: {
          source: logInfoData.source,
          source_p: logInfoData.source_p,
          source_pp: logInfoData.source_pp,
          id: requestInfo?.bizIdentity,
          softType: '0',
          forumId: forum && forum.content && forum.content.id,
        },
      }),
    );
    dispatch(
      logPostInfo({
        source_p: logInfoData.source,
        source_pp: logInfoData.source_p,
      }),
    );
    if (forum && forum.content && forum.content.id) {
      history.push(`${CONTEXT}${MICROCONTEXT}${MICROCONTEXT}/forumdetail?id=${forum.content.id}`);
    } else {
      history.push(`${CONTEXT}${MICROCONTEXT}${MICROCONTEXT}/forumlist`);
    }
  };

  const handleTagLog = useCallback(({ targetname, tagid }) => {
    dispatch(
      logging({
        category: 'C',
        action: 'Comment_Tags',
        label: '',
        param2: {
          source: logInfoData.source,
          source_p: logInfoData.source_p,
          source_pp: logInfoData.source_pp,
          targetname,
          tagid,
          id: requestInfo?.bizIdentity?.replace('zt_', ''),
          version: requestInfo?.version,
          type: requestInfo?.type,
        },
      }),
    );
  }, []);

  const handleSortLog = useCallback(({ name, text }) => {
    dispatch(
      logging({
        category: 'C',
        action: 'Comment_Sort',
        label: '',
        param2: {
          source: logInfoData.source,
          source_p: logInfoData.source_p,
          source_pp: logInfoData.source_pp,
          sortname: text,
          sortid: name,
          id: requestInfo?.bizIdentity?.replace('zt_', ''),
          version: requestInfo?.version,
          type: requestInfo?.type,
        },
      }),
    );
  }, []);
  const logCommentViewTime = useCallback(() => {
    if (Date.now() - showCommentTime.current > 0) {
      dispatch(
        logging({
          category: 'I',
          action: 'Comment_View_Time',
          label: '',
          param2: {
            source: logInfoData.source,
            source_p: logInfoData.source_p,
            source_pp: logInfoData.source_pp,
            id: requestInfo?.bizIdentity?.replace('zt_', ''),
            type: requestInfo?.type,
            time: Date.now() - showCommentTime.current,
          },
        }),
      );
    }
  }, [comments, releaseInfo]);

  useEffect(() => {
    // 添加评论
    if (releaseInfo?.funcs?.indexOf('1') > -1 && addCommentInfo) {
      getCommentList({
        refresh: true,
      });
      return;
    }
    if (addCommentInfo && !releaseInfo?.commentContent) {
      setComments(list => [addCommentInfo, ...list]);
    } else if (addCommentInfo && releaseInfo?.commentContent) {
      setComments(list => {
        const target = list.findIndex(item => item.id === addCommentInfo.id);
        if (target > -1) {
          const newList = [...list];
          newList.splice(target, 1, addCommentInfo);
          return newList;
        }
        return list;
      });
    }
  }, [addCommentInfo]);

  useEffect(() => {
    if (data) {
      getCommentList({
        refresh: true,
      });
    }
  }, [loginStatus, queryParams]);
  useActivate(() => {
    if (history.action === 'PUSH') {
      if (data) {
        getCommentList({
          refresh: true,
        });
      }
    }
  });

  useEffect(() => {
    if (inView) {
      showCommentTime.current = Date.now();
    }
    if (showCommentTime.current && !inView) {
      logCommentViewTime();
      showCommentTime.current = null;
    }
  }, [inView]);
  useActivate(() => {
    showCommentTime.current = Date.now();
  });

  useUnactivate(() => {
    if (showCommentTime.current) {
      logCommentViewTime();
      showCommentTime.current = null;
    }
  });

  if (comments?.length < 1 && data?.commentUserNum < 1 && loading.current) {
    return null;
  }
  return (
    <div className={styles.comment} ref={ref}>
      <div className={styles.comment_header} id="soft_comment_list_header">
        <div className={styles.comment_header_left}>
          <div className={styles.comment_header_text}>网友评论</div>
          {data?.commentUserNum > 0 && (
            <div className={styles.comment_header_total}>已有{data?.commentUserNum}人参与评论</div>
          )}
        </div>

        {pathname === `${CONTEXT}/special` && (
          <div>
            <Select
              options={sorts}
              defaultValue={sorts[1]}
              handleChange={option => {
                setQueryParams({ ...queryParams, sort: option?.name });
                handleSortLog(option);
              }}
              selectStyle={{ lineHeight: '27px', color: '#999' }}
              selectModal={styles.selectModal}
            />
          </div>
        )}
      </div>
      {/* 权限控制 */}
      {(releaseInfo?.commentSwitch === 1 || releaseInfo?.commentSwitch === 0) && (
        <>
          {forum?.hasForum && (
            <div className={styles.commment_advert} onClick={handleForum}>
              <div className={styles.advert_logo}>
                <img src={CoolLogo} alt="" />
              </div>
              <div className={styles.advert_split}>|</div>
              <div className={styles.advert_desc}>
                <div className={styles.advert_desc_text}>
                  {forum?.content?.title
                    ? `#${forum?.content?.title}`
                    : `想对 ${forum?.softName} 分享或提问？去酷软圈论坛畅所欲言～`}
                </div>
                <div className={styles.advert_btn}>去看看 &gt;</div>
              </div>
            </div>
          )}
          {releaseInfo?.funcs?.indexOf('2') > -1 && (
            <div className={styles.label}>
              <div className={styles.label_content}>
                {data?.labelUserNum?.filter(label => label?.userNum >= 4)?.length > 0 && (
                  <div
                    onClick={() => {
                      setQueryParams({ ...queryParams, labelCode: -1 });
                      handleTagLog({
                        tagid: '-1',
                        tagname: '全部',
                      });
                    }}
                    className={`${styles.label_item} ${
                      queryParams.labelCode === -1 ? styles.label_item_active : ''
                    }`}
                  >
                    全部
                  </div>
                )}
                {data?.labelUserNum
                  ?.filter(label => label?.userNum >= 4)
                  .map(label => {
                    return (
                      <div
                        key={label?.code}
                        className={`${styles.label_item} ${
                          queryParams.labelCode === label?.code ? styles.label_item_active : ''
                        }`}
                        onClick={() => {
                          setQueryParams({ ...queryParams, labelCode: label?.code });
                          handleTagLog({
                            tagid: label?.code,
                            tagname: label?.name,
                          });
                        }}
                      >
                        {label?.name} {label?.userNum ? label?.userNum : ''}
                      </div>
                    );
                  })}
              </div>
              <div>
                <Select
                  options={sorts}
                  defaultValue={sorts[1]}
                  handleChange={option => {
                    setQueryParams({ ...queryParams, sort: option?.name });
                    handleSortLog(option);
                  }}
                  selectStyle={{ lineHeight: '30px', color: '#999' }}
                  selectModal={styles.selectModal}
                />
              </div>
              <div>
                <Select
                  options={grades}
                  defaultValue={grades[0]}
                  handleChange={option => {
                    setQueryParams({ ...queryParams, grade: option?.name });
                    handleSortLog(option);
                  }}
                  selectStyle={{ lineHeight: '30px', color: '#999' }}
                  selectModal={styles.selectModal}
                />
              </div>
            </div>
          )}

          {comments?.length > 0 && (
            <div className={styles.comment_list}>
              <InfiniteScroll
                pageStart={1}
                loadMore={loadMore}
                hasMore={
                  comments?.length < commentPagenation?.count && commentPagenation?.count > 0
                }
                loader={
                  <div className="loader" key={0}>
                    ----------加载中----------
                  </div>
                }
                initialLoad={false}
                useWindow={false}
                getScrollParent={() => scrollEl}
              >
                <div className={styles.content}>
                  {[...comments].map((item, index) => {
                    return (
                      <CommentDetail
                        commentInfo={item}
                        key={item.id}
                        dataIndex={index}
                        data={data}
                        handleUpdate={handleUpdate} //点赞更新数据
                        handleUpdateByEditor={handleUpdateByEditor} // 编辑器提交产生的更新数据
                        releaseInfo={releaseInfo}
                        requestInfo={requestInfo}
                        currCommentOn={currCommentOn}
                        updateCommentOn={datas => {
                          setCurrmentOn(datas);
                        }} //记录最近一次点击回复的信息
                        scrollEl={scrollEl}
                      />
                    );
                  })}
                </div>
              </InfiniteScroll>
            </div>
          )}
        </>
      )}
      {releaseInfo?.commentSwitch === 2 && (
        <div className={styles.comment_disable}>由于政策管控，暂无法查看评论</div>
      )}
      {releaseInfo?.commentSwitch !== 2 &&
        (comments?.length === 0 ||
          comments?.filter(item => {
            return (
              item?.contentInfo?.text ||
              item?.contentInfo?.labelCodes?.length > 0 ||
              item?.contentInfo?.imgs?.length > 0 ||
              [...(item?.contentInfo?.appList || []), ...(item?.contentInfo?.specialList || [])]
                .length > 0
            );
          })?.length === 0) && (
          <div className={styles.comment_disable}>还没有评论，抢个沙发吧~</div>
        )}
    </div>
  );
}

export default props => {
  return <List {...props} />;
};
